export default __webpack_public_path__ + "static/io-a4d91cae11c745e2df548f824c016b8f.svg";